import { Link, useLocation } from "react-router-dom";
import { Cloud, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

const COPY = {
  teams: ["Teams zijn beschikbaar met een account", "Maak een account om leden uit te nodigen en samen te werken."],
  export: ["Export is beschikbaar met een account", "Met een account kun je gegevens veilig synchroniseren en exporteren."],
  cloudSync: ["Bewaar je gegevens in de cloud", "Maak een account om lokale gegevens te beveiligen en op meerdere apparaten te gebruiken."],
  accountDeletion: ["Je gebruikt Bijen App zonder account", "Je lokale gastgegevens kun je verwijderen via de appopslag of door de app te verwijderen."],
  queenBreeding: ["Kweekcentrum is beschikbaar met een account", "Maak een account om afstamming, teeltseries en selectiegegevens veilig en blijvend te bewaren."],
};

export default function AccountRequired() {
  const feature = new URLSearchParams(useLocation().search).get("feature") || "cloudSync";
  const [title, description] = COPY[feature] || COPY.cloudSync;
  return (
    <div className="mx-auto flex min-h-[65vh] max-w-md items-center px-4 text-center">
      <div className="w-full rounded-2xl border border-zinc-200 bg-white p-6">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50 text-amber-700"><Cloud className="h-7 w-7" /></span>
        <h1 className="mt-4 font-display text-2xl font-bold text-zinc-950">{title}</h1>
        <p className="mt-2 text-sm leading-6 text-zinc-600">{description}</p>
        <div className="mt-4 flex items-center justify-center gap-2 text-xs font-semibold text-zinc-500"><ShieldCheck className="h-4 w-4" />Je lokale gegevens blijven behouden bij het upgraden.</div>
        <Button asChild className="mt-6 h-12 w-full bg-amber-600 font-bold hover:bg-amber-700"><Link to="/register">Account aanmaken</Link></Button>
        <Button asChild variant="ghost" className="mt-2 h-11 w-full"><Link to="/">Niet nu</Link></Button>
      </div>
    </div>
  );
}
